__turbopack_context__.v({
  "item": "stats-module-scss-module__xGSERa__item",
  "label": "stats-module-scss-module__xGSERa__label",
  "percentage": "stats-module-scss-module__xGSERa__percentage",
  "stats": "stats-module-scss-module__xGSERa__stats",
});
